import React from "react";

export default function Eighteen({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M258.91.24H41.09A6.19,6.19,0,0,0,34.9,6.43v279A6.15,6.15,0,0,0,41,291.57h5.71c0-.09,0-.18,0-.28V241.51a10.84,10.84,0,0,1,.2-2.07H46.1c-3.26,0-5.9-1.89-5.9-5.16V11.64a5.91,5.91,0,0,1,5.91-5.91H253.82a5.91,5.91,0,0,1,5.91,5.91V234.28a5.91,5.91,0,0,1-3,5.16H117.56a10.84,10.84,0,0,1,.2,2.07v49.78c0,.1,0,.19,0,.28H259a6.15,6.15,0,0,0,6.12-6.12V251.67h0V6.43A6.19,6.19,0,0,0,258.91.24Z" />
      <polygon points="73.63 279.03 92.53 279.03 92.53 253.96 73.63 253.77 73.63 279.03" />
      <path d="M83.13,280.64a2.56,2.56,0,0,0-2.57,2.57,2.57,2.57,0,1,0,2.57-2.57Z" />
      <path d="M79.9,251.3h6.45a1.8,1.8,0,0,0,1.81-1.8,1.87,1.87,0,0,0-1.81-1.8H80a1.8,1.8,0,1,0-.09,3.6Z" />
      <path d="M106.12,233.82H58.36a8.71,8.71,0,0,0-8.7,8.7v47.76a8.71,8.71,0,0,0,8.7,8.7h47.76a8.71,8.71,0,0,0,8.7-8.7V242.52A8.71,8.71,0,0,0,106.12,233.82ZM95.47,261.65v21.84a3.91,3.91,0,0,1-3.89,3.89H74.77a3.91,3.91,0,0,1-3.89-3.89V249.31a3.91,3.91,0,0,1,3.89-3.89H91.58a4,4,0,0,1,3.89,3.89Z" />
      {children}
    </svg>
  );
}
